import { Box, Typography } from "@mui/material";
import React from "react";

type RRDDirectMailPlaceholderProps = {
  placeholder?: string;
  subPlaceholder?: string;
};

function RRDDirectMailPlaceholder({
  placeholder,
  subPlaceholder,
}: RRDDirectMailPlaceholderProps) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        width: "100%",
      }}
    >
      <Typography variant="caption" fontWeight={600}>
        {placeholder}
      </Typography>
      {subPlaceholder && (
        <Typography variant="caption" fontWeight={500}>
          {subPlaceholder}
        </Typography>
      )}
    </Box>
  );
}

export default RRDDirectMailPlaceholder;
